import * as rest from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { IEventLogRow } from '../util/DataModelInterface';
import * as storage from '../util/StorageUtil';

export const readLog = async (start: string = "", end: string = "") => {
  // const url = `${getFunctionBaseUrl()}/api/readLog/${start}/${end}/`;
  let periodQuery = "";
  if (start && end) {
    periodQuery = `${start}/${end}/`;
  }
  const url = `${getFunctionBaseUrl()}/api/readLog/${periodQuery}`;
  const response = await rest.get(url);
  if (response?.result) {
    // console.log("readLog server time:" + response.time);
    return response.result as IEventLogRow[];
  } else {
    return response;
  }
}

export const writeLog = async (event: IEventLogRow) => {
  const url = `${getFunctionBaseUrl()}/api/writeLog`;
  const response = await rest.post(url, event);  
  return response;
}

export const makeLogEvent = async (event: string, type: string, info: string) => {
  // console.log("Logging event", event);
  const userInfo = storage.getUser();
  if (!userInfo) {
      console.error("No user");
      return;
  }
  let company = userInfo.companies ? userInfo.companies.map(c => c.name).join(", ") : "";
  let logEvent = {
      type: type,
      event: event,
      user_name: userInfo.name,
      company: company,
      info: info
  } as IEventLogRow;

  let response = await writeLog(logEvent);
  // console.log("makeLogEvent result", response?.result);
  // console.log("makeLogEvent server time:" + response?.time);
  return response?.result;
}

export const exportLog = async (type: string, data: any) => {
  const url = `${getFunctionBaseUrl()}/api/exportLog/${type}`;
  const response = await rest.exporting(url, data);
  return response;
}

export const readMessageLog = async (start: string = "", end: string = "") => {
  let periodQuery = "";
  if (start && end) {
    periodQuery = `${start}/${end}/`;
  }
  const url = `${getFunctionBaseUrl()}/api/readMessageLog/${periodQuery}`;
  const response = await rest.get(url);
  if (response?.result) {
    return response.result as IEventLogRow[];
  } else {
    return response;
  }
}